(function() {
  if (!Theme || !Theme.metaobjects || !Array.isArray(Theme.metaobjects.store_redirects)) {
    return;
  }

  const currentUrl = window.location.href;
  const isAuthenticated = !!Theme?.customer_logged_in;
  const performRedirect = (redirects) => {
    for (const redirect of redirects) {
      if (typeof redirect.redirect_from !== 'string' || typeof redirect.redirect_to !== 'string') {
        continue;
      }

      const redirectCondition = redirect?.redirect_condition;

      if (redirectCondition === 'guest-user' && isAuthenticated) {
        continue;
      }
      if (redirectCondition === 'authenticated-user' && !isAuthenticated) {
        continue;
      }

      if (currentUrl === redirect.redirect_from || 
          currentUrl.startsWith(redirect.redirect_from + '?') || 
          currentUrl.startsWith(redirect.redirect_from + '#')) {
        window.location.href = redirect.redirect_to;
        return;
      }
    }
  };

  performRedirect(Theme.metaobjects.store_redirects);
})();